angular.module('iw.frontyard.signup', [
    'iw.frontyard.app',
    'iw.frontyard.error'
]);